import React, {useEffect, useRef, useState} from 'react';
import {ScrollView, View} from 'react-native';
import {Snackbar} from 'react-native-paper';
import ViewShot from 'react-native-view-shot';
import ClientSelect from 'src/hook-form-inputs/client';
import {BaseScreen} from 'src/design-system';
import ClientReport from 'src/modules/reports/components/client-report-beta';
import moment from 'moment';
import {subtractNMonths} from 'src/common-utils/subtractNMonths';
import {FormProvider, useForm, useWatch} from 'react-hook-form';
import {useStyle} from 'src/providers/style';
import {useSelector, useDispatch} from 'react-redux';
import {setFilters} from 'src/redux/reports-filters';

const Reports = ({}: any) => {
  const screenRef = useRef();
  const styles = useStyle();
  const dispatch = useDispatch();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [exportName, setExportName] = useState<string>('');
  const [showExportDlg, setShowExportDlg] = useState<string | undefined>(
    undefined,
  );

  const {selectedFilters: filters} = useSelector(
    (state: any) => state.reportsFilters,
  );

  const defaultValues = {
    startDate: subtractNMonths(1),
    endDate: new Date(),
    program: '',
    target: '',
    clients: filters.clients || '',
  };

  const methods = useForm({
    defaultValues,
  });

  const watchedStartDate = useWatch({
    control: methods.control,
    name: 'startDate',
  });
  const watchedEndDate = useWatch({control: methods.control, name: 'endDate'});
  const watchedClient = useWatch({control: methods.control, name: 'clients'});
  useEffect(() => {
    if (watchedClient !== filters.clients) {
      dispatch(
        setFilters({
          clients: watchedClient,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchedClient]);

  return (
    <BaseScreen
      title="Reports"
      snackbar={
        <Snackbar
          visible={showExportDlg !== undefined}
          onDismiss={() => setShowExportDlg(undefined)}
          duration={3000}
          action={{
            label: 'Dismiss',
            onPress: () => {},
          }}>
          {showExportDlg} was downloaded.
        </Snackbar>
      }>
      <FormProvider {...methods}>
        <ScrollView style={[]}>
          <View style={[styles.marginLHorizontal]}>
            <View style={[styles.marginL, styles.flex]}>
              <ClientSelect multiple={false} label={'Select Client'} />
            </View>
          </View>
          {watchedClient ? (
            <ViewShot ref={screenRef}>
              <ClientReport
                client={watchedClient}
                startDate={moment(watchedStartDate).format()}
                endDate={moment(watchedEndDate).format()}
                setExportName={setExportName}
              />
            </ViewShot>
          ) : (
            <></>
          )}
        </ScrollView>
      </FormProvider>
    </BaseScreen>
  );
};

export default Reports;
